import React from 'react';

const Header = () => (
  <header className="bg-white w-full px-[64px] py-4">
    <img src="/images/credence-logo.png" alt="Credence logo" className="h-8" />
  </header>
);

export default Header;